import { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';
import {
  convertQuoteAssetPathToUrl as convertQuoteAssetPathToUrlHelper,
  convertQuoteAssetPathToVirtualPath as convertQuoteAssetPathToVirtualPathHelper,
  convertQuoteItemAssetPathToUrl as convertQuoteItemAssetPathToUrlHelper,
  convertQuoteItemAssetPathToVirtualPath as convertQuoteItemAssetPathToVirtualPathHelper,
  createAssetDocumentPath as createAssetDocumentPathHelper,
  createFullQuoteAssetPath as createFullQuoteAssetPathHelper,
  createFullQuoteItemAssetPath as createFullQuoteItemAssetPathHelper,
  createQuoteAssetPath as createQuoteAssetPathHelper,
  createQuoteItemAssetPath as createQuoteItemAssetPathHelper
} from '../quotes/data/v6/helper-functions';
import {
  InputCreateQuote,
  InputCreateQuoteItem,
  InputDeleteQuote,
  InputDeleteQuoteItem,
  InputDuplicateQuote,
  InputDuplicateQuoteItem,
  InputSetQuoteAssignedToUser,
  InputUpdateQuote,
  InputUpdateQuoteItem,
  InputUpdateQuoteItems,
  type InputUpdateQuotePrice,
  InputUpdateQuoteSetState,
  RequestGetIssuedQuoteRevenue,
  RequestGetQuote,
  RequestGetQuoteItemsProviderData,
  RequestGetQuoteItemsSummary,
  RequestGetQuoteItemsSummaryById,
  type RequestGetQuoteNumbersByQuoteItemIds,
  RequestGetQuoteSetSummary,
  RequestGetQuoteStateAudit,
  RequestGetQuoteSummary,
  RequestGetQuoteTotalsByState,
  RequestGetQuoteUserIdsByOwnerId,
  RequestGetQuoteUserIdsByOwnerIds,
  ResultCreateQuote,
  ResultCreateQuoteItem,
  ResultDeleteQuote,
  ResultDeleteQuoteItem,
  ResultDuplicateQuote,
  ResultDuplicateQuoteItem,
  ResultGetIssuedQuoteRevenue,
  ResultGetQuote,
  ResultGetQuoteItemsProviderData,
  ResultGetQuoteItemsSummary,
  ResultGetQuoteItemsSummaryById,
  type ResultGetQuoteNumbersByQuoteItemIds,
  ResultGetQuoteSetSummary,
  ResultGetQuoteStateAudit,
  ResultGetQuoteSummary,
  ResultGetQuoteTotalsByState,
  ResultGetQuoteUserIdsByOwnerId,
  ResultGetQuoteUserIdsByOwnerIds,
  ResultSetQuoteAssignedToUser,
  ResultUpdateQuote,
  ResultUpdateQuoteItem,
  ResultUpdateQuoteItems,
  type ResultUpdateQuotePrice,
  ResultUpdateQuoteSetState
} from './dealer-api-interface-quote';
import { QuoteApi, QuoteAssetType, QuoteItemAssetType } from './quote-api';

export class QuoteApiImpl implements QuoteApi {
  api: ApiCommunications;

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  async updateQuotePrice(input: InputUpdateQuotePrice): NullPromise<ResultUpdateQuotePrice> {
    return await this.api.post<ResultUpdateQuotePrice>('api/Quote/UpdateQuotePrice', input);
  }

  async deleteQuote(input: InputDeleteQuote): NullPromise<ResultDeleteQuote> {
    return await this.api.post<ResultDeleteQuote>('api/Quote/DeleteQuote', input);
  }

  async duplicateQuote(input: InputDuplicateQuote): NullPromise<ResultDuplicateQuote> {
    return await this.api.post<ResultDuplicateQuote>('api/Quote/DuplicateQuote', input);
  }

  async getQuoteSummary(request: RequestGetQuoteSummary): NullPromise<ResultGetQuoteSummary> {
    return await this.api.post<ResultGetQuoteSummary>('api/Quote/GetQuoteSummary', request);
  }

  async getQuoteSetSummary(request: RequestGetQuoteSetSummary): NullPromise<ResultGetQuoteSetSummary> {
    return await this.api.post<ResultGetQuoteSetSummary>('api/Quote/GetQuoteSetSummary', request);
  }

  async getQuote(request: RequestGetQuote): NullPromise<ResultGetQuote> {
    return await this.api.post<ResultGetQuote>('api/Quote/GetQuote', request);
  }

  async createQuote(input: InputCreateQuote): NullPromise<ResultCreateQuote> {
    return await this.api.post<ResultCreateQuote>('api/Quote/CreateQuote', input);
  }

  async updateQuote(input: InputUpdateQuote): NullPromise<ResultUpdateQuote> {
    return await this.api.post<ResultUpdateQuote>('api/Quote/UpdateQuote', input);
  }

  async createQuoteItem(input: InputCreateQuoteItem): NullPromise<ResultCreateQuoteItem> {
    return await this.api.post<ResultCreateQuoteItem>('api/QuoteItem/CreateQuoteItem', input);
  }

  async updateQuoteItem(input: InputUpdateQuoteItem): NullPromise<ResultUpdateQuoteItem> {
    return await this.api.post<ResultUpdateQuoteItem>('api/QuoteItem/UpdateQuoteItem', input);
  }

  async updateQuoteItems(input: InputUpdateQuoteItems): NullPromise<ResultUpdateQuoteItems> {
    return await this.api.post<ResultUpdateQuoteItems>('api/QuoteItem/UpdateQuoteItems', input);
  }

  async deleteQuoteItem(input: InputDeleteQuoteItem): NullPromise<ResultDeleteQuoteItem> {
    return await this.api.post<ResultDeleteQuoteItem>('api/QuoteItem/DeleteQuoteItem', input);
  }

  async duplicateQuoteItem(input: InputDuplicateQuoteItem): NullPromise<ResultDuplicateQuoteItem> {
    return await this.api.post<ResultDuplicateQuoteItem>('api/QuoteItem/DuplicateQuoteItem', input);
  }

  async getQuoteTotalsByState(request: RequestGetQuoteTotalsByState): NullPromise<ResultGetQuoteTotalsByState> {
    return await this.api.post<ResultGetQuoteTotalsByState>('api/Quote/GetQuoteTotalsByState', request);
  }

  async getQuoteItemsSummary(request: RequestGetQuoteItemsSummary): NullPromise<ResultGetQuoteItemsSummary> {
    return await this.api.post<ResultGetQuoteItemsSummary>('api/QuoteItem/GetQuoteItemsSummary', request);
  }
  async getQuoteItemsProviderData(
    request: RequestGetQuoteItemsProviderData
  ): NullPromise<ResultGetQuoteItemsProviderData> {
    return await this.api.post<ResultGetQuoteItemsProviderData>('api/QuoteItem/GetQuoteItemsProviderData', request);
  }
  convertQuoteItemAssetPathToVirtualPath(
    quoteId: string | undefined,
    quoteItemId: string | undefined,
    assetPath: string | undefined
  ): string {
    return convertQuoteItemAssetPathToVirtualPathHelper(quoteId, quoteItemId, assetPath);
  }
  convertQuoteItemAssetPathToUrl(
    quoteId: string | undefined,
    quoteItemId: string | undefined,
    assetPath: string | undefined,
    tag?: string
  ): string {
    return convertQuoteItemAssetPathToUrlHelper(quoteId, quoteItemId, assetPath, tag);
  }

  convertQuoteAssetPathToVirtualPath(quoteId: string | undefined, assetPath: string | undefined): string {
    return convertQuoteAssetPathToVirtualPathHelper(quoteId, assetPath);
  }
  convertQuoteAssetPathToUrl(quoteId: string | undefined, assetPath: string | undefined): string {
    return convertQuoteAssetPathToUrlHelper(quoteId, assetPath);
  }

  createFullQuoteAssetPath(quoteId: string, assetType: QuoteItemAssetType, ext: string) {
    return createFullQuoteAssetPathHelper(quoteId, assetType, ext);
  }
  createQuoteAssetPath(assetType: QuoteAssetType, ext: string) {
    return createQuoteAssetPathHelper(assetType, ext);
  }

  createFullQuoteItemAssetPath(
    quoteId: string,
    quoteItemId: string,
    assetType: QuoteItemAssetType,
    ext: string
  ): string {
    return createFullQuoteItemAssetPathHelper(quoteId, quoteItemId, assetType, ext);
  }
  createQuoteItemAssetPath(assetType: QuoteItemAssetType, ext: string): string {
    return createQuoteItemAssetPathHelper(assetType, ext);
  }

  createAssetDocumentPath(origin: string, docType: string, name: string, ext: string): string {
    return createAssetDocumentPathHelper(origin, docType, name, ext);
  }

  async getQuoteItemsSummaryById(
    request: RequestGetQuoteItemsSummaryById
  ): NullPromise<ResultGetQuoteItemsSummaryById> {
    return await this.api.post<ResultGetQuoteItemsSummaryById>('api/QuoteItem/GetQuoteItemsSummaryById', request);
  }

  async getQuoteNumbersByQuoteItemIds(
    request: RequestGetQuoteNumbersByQuoteItemIds
  ): NullPromise<ResultGetQuoteNumbersByQuoteItemIds> {
    return await this.api.post<ResultGetQuoteNumbersByQuoteItemIds>(
      'api/QuoteItem/GetQuoteNumbersByQuoteItemIds',
      request
    );
  }

  async getQuoteStateAudit(request: RequestGetQuoteStateAudit): NullPromise<ResultGetQuoteStateAudit> {
    return await this.api.post<ResultGetQuoteStateAudit>('api/Quote/GetQuoteStateAudit', request);
  }

  async updateQuoteSetState(input: InputUpdateQuoteSetState): NullPromise<ResultUpdateQuoteSetState> {
    return await this.api.post<ResultUpdateQuoteSetState>('api/Quote/UpdateQuoteSetState', input);
  }

  async getIssuedQuoteRevenue(request: RequestGetIssuedQuoteRevenue): NullPromise<ResultGetIssuedQuoteRevenue> {
    return await this.api.post<ResultGetIssuedQuoteRevenue>('api/Quote/GetIssuedQuoteRevenue', request);
  }

  async getQuoteUserIdsByOwnerId(
    request: RequestGetQuoteUserIdsByOwnerId
  ): NullPromise<ResultGetQuoteUserIdsByOwnerId> {
    return await this.api.post<ResultGetQuoteUserIdsByOwnerId>(`api/Quote/GetQuoteUserIdsByOwnerId`, request);
  }

  async getQuoteUserIdsByOwnerIds(
    request: RequestGetQuoteUserIdsByOwnerIds
  ): NullPromise<ResultGetQuoteUserIdsByOwnerIds> {
    return await this.api.post<ResultGetQuoteUserIdsByOwnerIds>(`api/Quote/GetQuoteUserIdsByOwnerIds`, request);
  }

  async setAuthorForQuotes(input: InputSetQuoteAssignedToUser): NullPromise<ResultSetQuoteAssignedToUser> {
    return await this.api.post<ResultSetQuoteAssignedToUser>('api/Quote/SetQuoteAssignedToUser', input);
  }
}
